require("bootstrap/js/dist/collapse");
